<div class="swiper-container">
  <swiper
    [style.width]="'100%'"
    [pagination]="{ clickable: true }"
    [spaceBetween]="24"
    [slidesPerView]="1.5"
    [pagination]="false"
    [breakpoints]="swiperBreakpoints"
    [allowTouchMove]="!getEmptySlots(videos.length).length"
    [allowSlideNext]="!getEmptySlots(videos.length).length"
    [allowSlidePrev]="!getEmptySlots(videos.length).length"
    [navigation]="{
      prevEl: '#custom-prev-' + index,
      nextEl: '#custom-next-' + index,
      enabled: !getEmptySlots(videos.length).length
    }"
    [attr.id]="'swiper' + index"
    class="swiper"
  >
    <ng-template swiperSlide *ngFor="let video of videos">
      <app-video-list-card
        class="video-card"
        [video]="video"
        (imageHeightChanged)="onImageHeightChanged($event)"
        [bgTheme]="bgTheme"
      ></app-video-list-card>
    </ng-template>
    <ng-template swiperSlide *ngFor="let empty of getEmptySlots(videos.length)">
      <div class="video-card-empty-card"></div>
    </ng-template>
  </swiper>
  <ng-container *ngIf="showButtons && !getEmptySlots(videos.length).length">
    <button class="custom-prev" [attr.id]="'custom-prev-' + index">
      <img
        src="assets/icons/icon-prev.svg"
        alt="Ícone de data"
        class="icon-prev"
      />
    </button>
    <button class="custom-next" [attr.id]="'custom-next-' + index">
      <img
        src="assets/icons/icon-next.svg"
        alt="Ícone de data"
        class="icon-next"
      />
    </button>
  </ng-container>
</div>
